const data = {
  'Selected': 'Geselecteerd: {0} van {1}',
  'Uploading files': 'Geüpload: {0}% van {1}',
  'File size error': '{0} is te groot, maximale grootte is {1}',
  'Upload failed': '{0} upload mislukt',
  'Per page': '{0} per pagina',
  'Folder': 'Map',
  'Login failed, please try again': 'Login mislukt, probeer het nog eens...',
  'Already logged in': 'U bent al ingelogd...',
  'Please enter username and password': 'Geef gebruikersnaam en wachtwoord',
  'Not Found': 'Niet gevonden',
  'Not Allowed': 'Niet toegestaan',
  'Please log in': 'Log eerst in',
  'Unknown error': 'Onbekende fout',
  'Add files': 'Bestanden toevoegen',
  'New': 'Nieuw',
  'New name': 'Nieuwe naam',
  'Username': 'Gebruikersnaam',
  'Password': 'Wachtwoord',
  'Login': 'Log in',
  'Logout': 'Log uit',
  'Profile': 'Profiel',
  'No pagination': 'Geen onderverdeling in pagina\'s',
  'Time': 'Tijd',
  'Name': 'Naam',
  'Size': 'Grootte',
  'Home': 'Thuismap',
  'Copy': 'Kopieer',
  'Move': 'Verplaats',
  'Rename': 'Hernoem',
  'Required': 'Vereist veld',
  'Zip': 'Zip',
  'Batch Download': 'Groepsdownload',
  'Unzip': 'Uitpakken',
  'Delete': 'Verwijder',
  'Download': 'Download',
  'Copy link': 'Kopieer link',
  'Done': 'Klaar',
  'File': 'Bestand',
  'Drop files to upload': 'Sleep bestanden hierheen om ze te uploaden',
  'Close': 'Sluiten',
  'Select Folder': 'Selecteer Map',
  'Users': 'Gebruikers',
  'Files': 'Bestanden',
  'Role': 'Rol',
  'Cancel': 'Afbreken',
  'Paused': 'Gepauseerd',
  'Confirm': 'Bevestig',
  'Create': 'Nieuw',
  'User': 'Gebruiker',
  'Admin': 'Beheerder',
  'Save': 'Opslaan',
  'Read': 'Lezen',
  'Write': 'Schrijven',
  'Upload': 'Uploaden',
  'Permissions': 'Permissies',
  'Homedir': 'Thuismap',
  'Leave blank for no change': 'Laat leeg om ongewijzigd te laten',
  'Are you sure you want to do this?': 'Weet u het zeker?',
  'Are you sure you want to allow access to everyone?': 'Weet u zeker dat u iedereen toegang wil geven?',
  'Are you sure you want to stop all uploads?': 'Weet u zeker dat u alle uploads wil stoppen?',
  'Something went wrong': 'Er is iets foutgegaan',
  'Invalid directory': 'Ongeldige map',
  'This field is required': 'This field is required',
  'Username already taken': 'Naam is al in gebruik',
  'User not found': 'Gebruiker niet gevonden',
  'Old password': 'Oud wachtwoord',
  'New password': 'Nieuw wachtwoord',
  'Wrong password': 'Fout wachtwoord',
  'Updated': 'Aangepast',
  'Deleted': 'Verwijderd',
  'Your file is ready': 'Uw bestand is verwerkt',
  'View': 'View',
  'Search': 'Search',
  'Download permission': 'Download',
  'Guest': 'Guest',
}

export default data

